(() => {
  const normalize = (value) => value.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLocaleLowerCase().trim();
  const languageCopy = {
    en: ['Search languages…', 'No languages found.'],
    lt: ['Ieškoti kalbos…', 'Kalbų nerasta.'],
    cs: ['Hledat jazyk…', 'Žádné jazyky nenalezeny.'],
    da: ['Søg efter sprog…', 'Ingen sprog fundet.'],
    nl: ['Taal zoeken…', 'Geen talen gevonden.'],
    fi: ['Hae kieltä…', 'Kieliä ei löytynyt.'],
    fr: ['Rechercher une langue…', 'Aucune langue trouvée.'],
    de: ['Sprache suchen…', 'Keine Sprachen gefunden.'],
    el: ['Αναζήτηση γλώσσας…', 'Δεν βρέθηκαν γλώσσες.'],
    hu: ['Nyelv keresése…', 'Nem található nyelv.'],
    it: ['Cerca lingua…', 'Nessuna lingua trovata.'],
    pl: ['Szukaj języka…', 'Nie znaleziono języków.'],
    pt: ['Pesquisar idioma…', 'Nenhum idioma encontrado.'],
    ro: ['Caută o limbă…', 'Nu s-au găsit limbi.'],
    ru: ['Поиск языка…', 'Языки не найдены.'],
    es: ['Buscar idioma…', 'No se encontraron idiomas.'],
    sv: ['Sök språk…', 'Inga språk hittades.'],
    tr: ['Dil ara…', 'Dil bulunamadı.']
  };
  const enhancePicker = (wrapper, form) => {
    let activeDialog;
    const countryCache = new Map();
    const open = async (button) => {
      if (activeDialog?.open) return;
      const selector = button.closest('.localization__selector');
      const control = button.closest('country-selector, custom-select');
      const input = selector.querySelector('input[type="hidden"]');
      const isCountry = control.matches('country-selector');
      const title = selector.querySelector('.label').textContent.trim();
      const copy = languageCopy[document.documentElement.lang.split('-')[0]] || languageCopy.en;
      const countryControl = form.querySelector('country-selector');
      const dialog = document.createElement('dialog');
      dialog.className = 'mc-localization-dialog';
      dialog.id = `${button.id}-dialog`;
      dialog.setAttribute('aria-labelledby', 'mc-localization-title');
      const heading = document.createElement('h2');
      heading.id = 'mc-localization-title';
      heading.textContent = title;
      const close = document.createElement('button');
      close.type = 'button';
      close.className = 'mc-localization-close';
      close.setAttribute('aria-label', document.querySelector('.navigation__mobile-header .mobile-nav-toggle')?.getAttribute('aria-label') || title);
      close.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="m6 6 12 12M6 18 18 6"/></svg>';
      const header = document.createElement('div');
      header.className = 'mc-localization-heading';
      header.append(heading, close);
      const searchWrap = document.createElement('div');
      searchWrap.className = 'mc-localization-search';
      searchWrap.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="10.5" cy="10.5" r="6.5"/><path d="m16 16 4 4"/></svg>';
      const search = document.createElement('input');
      search.type = 'search';
      search.autocomplete = 'off';
      search.placeholder = isCountry ? countryControl.querySelector('.country-selector__input').placeholder : copy[0];
      search.setAttribute('aria-label', search.placeholder);
      searchWrap.append(search);
      const list = document.createElement('div');
      list.className = 'mc-localization-options';
      list.setAttribute('aria-busy', 'true');
      const status = document.createElement('p');
      status.className = 'mc-localization-status';
      status.setAttribute('role', 'status');
      status.textContent = '…';
      list.append(status);
      dialog.append(header, searchWrap, list);
      document.body.append(dialog);
      activeDialog = dialog;
      button.setAttribute('aria-expanded', 'true');
      button.setAttribute('aria-controls', dialog.id);
      button.setAttribute('aria-haspopup', 'dialog');
      const previousOverflow = document.documentElement.style.overflow;
      document.documentElement.style.overflow = 'hidden';
      const position = () => {
        const viewport = window.visualViewport;
        const height = viewport?.height || window.innerHeight;
        const sheetHeight = Math.min(680, height * 0.85);
        dialog.style.height = `${sheetHeight}px`;
        dialog.style.top = `${(viewport?.offsetTop || 0) + height - sheetHeight}px`;
        dialog.style.bottom = 'auto';
      };
      window.visualViewport?.addEventListener('resize', position);
      window.visualViewport?.addEventListener('scroll', position);
      window.addEventListener('resize', position);
      dialog.addEventListener('close', () => {
        window.visualViewport?.removeEventListener('resize', position);
        window.visualViewport?.removeEventListener('scroll', position);
        window.removeEventListener('resize', position);
        document.documentElement.style.overflow = previousOverflow;
        button.setAttribute('aria-expanded', 'false');
        button.removeAttribute('aria-controls');
        dialog.remove();
        activeDialog = null;
        button.focus({ preventScroll: true });
      }, { once: true });
      close.addEventListener('click', () => dialog.close());
      dialog.addEventListener('click', (event) => {
        if (event.target !== dialog) return;
        const box = dialog.getBoundingClientRect();
        if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) dialog.close();
      });
      dialog.addEventListener('keydown', (event) => {
        event.stopPropagation();
        if (event.key === 'Escape') {
          event.preventDefault();
          dialog.close();
        }
      });
      position();
      dialog.showModal();
      close.focus({ preventScroll: true });
      try {
        let options = control.querySelectorAll('.custom-select__option');
        if (isCountry) {
          const url = control.dataset.countriesUrl;
          if (!countryCache.has(url)) {
            const request = fetch(url).then(async (response) => {
              if (!response.ok) throw new Error('Countries unavailable');
              const template = document.createElement('template');
              template.innerHTML = await response.text();
              const countries = template.content.querySelectorAll('.custom-select__option');
              if (!countries.length) throw new Error('Countries unavailable');
              return countries;
            });
            countryCache.set(url, request);
            request.catch(() => countryCache.delete(url));
          }
          options = await countryCache.get(url);
        }
        if (!dialog.open) return;
        let names;
        let localNames;
        try {
          names = new Intl.DisplayNames(['en'], { type: isCountry ? 'region' : 'language' });
          localNames = new Intl.DisplayNames([document.documentElement.lang], { type: isCountry ? 'region' : 'language' });
        } catch {}
        const rows = Array.from(options).map((option) => {
          const row = document.createElement('button');
          row.type = 'button';
          row.className = 'mc-localization-option';
          row.dataset.value = option.dataset.value;
          const selected = option.dataset.value === input.value;
          row.setAttribute('aria-pressed', String(selected));
          const text = document.createElement('span');
          text.className = 'mc-localization-option-text';
          const name = option.querySelector('.country-option__name');
          const currency = option.querySelector('.country-option__currency');
          text.textContent = (name?.textContent || option.textContent).trim();
          row.append(text);
          if (currency) {
            const meta = document.createElement('span');
            meta.className = 'mc-localization-currency';
            meta.textContent = currency.textContent.trim();
            row.append(meta);
          }
          const check = document.createElement('span');
          check.className = 'mc-localization-check';
          check.setAttribute('aria-hidden', 'true');
          check.innerHTML = selected ? '<svg viewBox="0 0 24 24"><path d="m5 12 4 4L19 6"/></svg>' : '';
          row.append(check);
          row.dataset.search = normalize(`${option.textContent} ${option.dataset.value} ${names?.of(option.dataset.value) || ''} ${localNames?.of(option.dataset.value) || ''}`);
          row.addEventListener('click', () => {
            if (selected) { dialog.close(); return; }
            input.value = option.dataset.value;
            list.setAttribute('aria-busy', 'true');
            list.querySelectorAll('button').forEach((item) => { item.disabled = true; });
            form.submit();
          });
          return row;
        });
        rows.sort((a, b) => Number(b.getAttribute('aria-pressed') === 'true') - Number(a.getAttribute('aria-pressed') === 'true'));
        status.hidden = true;
        list.replaceChildren(...rows, status);
        list.setAttribute('aria-busy', 'false');
        const filterOptions = () => {
          const terms = normalize(search.value).split(/\s+/).filter(Boolean);
          rows.forEach((row) => { row.hidden = !terms.every((term) => row.dataset.search.includes(term)); });
          status.textContent = isCountry ? countryControl.querySelector('.country-selector__empty').textContent : copy[1];
          status.hidden = rows.some((row) => !row.hidden);
          list.scrollTop = 0;
        };
        search.addEventListener('input', filterOptions);
        filterOptions();
        search.addEventListener('keydown', (event) => {
          if (event.key === 'ArrowDown') {
            event.preventDefault();
            rows.find((row) => !row.hidden)?.focus();
          } else if (event.key === 'Enter') {
            event.preventDefault();
            rows.find((row) => !row.hidden)?.click();
          }
        });
        list.addEventListener('keydown', (event) => {
          if (!['ArrowDown', 'ArrowUp', 'Home', 'End'].includes(event.key)) return;
          event.preventDefault();
          const visible = rows.filter((row) => !row.hidden);
          const index = visible.indexOf(document.activeElement);
          const next = event.key === 'Home' ? 0 : event.key === 'End' ? visible.length - 1 : Math.max(0, Math.min(visible.length - 1, index + (event.key === 'ArrowDown' ? 1 : -1)));
          visible[next]?.focus();
        });
      } catch {
        list.setAttribute('aria-busy', 'false');
        status.textContent = countryControl?.dataset.loadingError || title;
      }
    };
    form.querySelectorAll('.custom-select__btn').forEach((button) => {
      button.setAttribute('aria-haspopup', 'dialog');
      button.removeAttribute('aria-controls');
    });
    ['mousedown', 'click', 'keydown'].forEach((name) => {
      wrapper.addEventListener(name, (event) => {
        const button = event.target.closest('.custom-select__btn');
        if (!button) return;
        if (name === 'keydown' && !['Enter', ' ', 'ArrowDown', 'ArrowUp'].includes(event.key)) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        if (name !== 'mousedown') open(button);
      }, true);
    });
  };
  const mount = () => {
    const footer = document.querySelector('.mobile-navigation-drawer__footer');
    const source = document.querySelector('.section-footer__localization form.localization');
    if (!footer || !source || footer.querySelector('form.localization')) return;
    const wrapper = document.createElement('div');
    wrapper.className = 'mc-mobile-localization';
    const clone = source.cloneNode(true);
    clone.querySelectorAll('script, noscript, link').forEach((element) => element.remove());
    const ids = new Map();
    [clone, ...clone.querySelectorAll('[id]')].forEach((element) => {
      if (element.id) {
        ids.set(element.id, `${element.id}-mobile`);
        element.id += '-mobile';
      }
    });
    clone.querySelectorAll('[for], [aria-controls], [aria-labelledby], [aria-describedby]').forEach((element) => {
      ['for', 'aria-controls', 'aria-labelledby', 'aria-describedby'].forEach((attribute) => {
        if (element.hasAttribute(attribute)) {
          element.setAttribute(attribute, element.getAttribute(attribute).split(' ').map((id) => ids.get(id) || id).join(' '));
        }
      });
    });
    clone.querySelectorAll('.label').forEach((label) => label.classList.remove('visually-hidden'));
    clone.addEventListener('change', (event) => {
      if (!event.detail?.selectedValue) return;
      const selector = event.target.closest('.localization__selector');
      const input = selector?.querySelector('input[type="hidden"]');
      if (!input) return;
      input.value = event.detail.selectedValue;
      clone.submit();
    });
    enhancePicker(wrapper, clone);
    wrapper.appendChild(clone);
    footer.prepend(wrapper);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mount, { once: true });
  else mount();
})();
